/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Slide2alt1Inputs */

const he_extension_slide2alt1 = /** @type {(inputs: Extension_Slide2alt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוסף PriceDrop מציג סטטיסטיקות מחירים מתקדמות`)
};

const en_extension_slide2alt1 = /** @type {(inputs: Extension_Slide2alt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PriceDrop extension showing advanced price statistics`)
};

/**
* | output |
* | --- |
* | "PriceDrop extension showing advanced price statistics" |
*
* @param {Extension_Slide2alt1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_slide2alt1 = /** @type {((inputs?: Extension_Slide2alt1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Slide2alt1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_slide2alt1(inputs)
	return en_extension_slide2alt1(inputs)
});
export { extension_slide2alt1 as "extension_slide2Alt" }